'use client'

import {
  LogOutIcon,
  ExternalLinkIcon,
  UserIcon,
} from 'lucide-react'
import { MenuProvider, MenuButton, MenuItem, Menu } from '@shared/components/Menu'
import Image from 'next/image'
import { useAuth, useOrganizationList, useUser } from '@clerk/nextjs'
import { useEffect } from 'react'
import { isDev } from '@shared/lib/utils'
import { Split } from '@christiankaindl/lyts'

const codaraUrl = isDev ? 'https://dev-dashboard.codara.com' : 'https://dashboard.codara.com'

export default function SignedInUserButton() {
  const { user } = useUser()
  const { orgId } = useAuth()

  const { isLoaded, setActive, userMemberships } = useOrganizationList({ userMemberships: { infinite: true } })

  useEffect(
    function setDefaultActiveOrg() {
      if (!isLoaded) return
      if (userMemberships.count === 0) return
      if (orgId) return // if org is already active, return

      setActive({ organization: userMemberships.data[0].organization.id })
    },
    [isLoaded, setActive, userMemberships, orgId],
  )

  if (!user) {
    return null
  }

  return (
    <MenuProvider>
      <MenuButton
        size='small'
        circular
        square
        style={{ color: '#A48757', backgroundColor: 'rgba(228, 177, 95, 0.2)' }}
      >
        <Image
          src={user.imageUrl}
          alt='User profile image'
          height={28}
          width={28}
        />
      </MenuButton>
      <Menu>
        <MenuItem href={codaraUrl} target='_blank'>
          <UserIcon size={16} />
          Codara Account
          <Split />
          <ExternalLinkIcon size={14} />
        </MenuItem>
        <MenuItem href='/logout'>
          <LogOutIcon size={16} />
          Logout
        </MenuItem>
      </Menu>
    </MenuProvider>
  )
}
